import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const legacyGinManageRoute: InvariantJiraRoute = {
	name: 'legacy-gin-manage',
	path: '(/secure/|/)ManageFilters.jspa',
};
